/*
  - přechod z gridu
    - na mobilu nascrolluje na obrázek
    - na desktopu zobrazí obrázek ve slideru
*/
import { galleryState as state } from './galleryState';
import { initializeGlide } from './gallerySlideOrScroll';
import { galleryScrollToItem as scrollToItem } from './galleryScrollToItem';
import { scrollToTop } from '@utils/scroll';
import { GTMTrack } from '@utils/dataLayer';
import { galleryResizeItems as resizeItems } from './galleryResizeItems';

export const fromDesktopGridToSlider = (position: number): void => {
  scrollToTop();

  // Nastavit slider
  const glide = initializeGlide();
  if (glide) {
    if (glide.enable) glide.enable();
    // Přesun ve slider bez animace
    glide.update({ animationDuration: 0 });
    if (glide.go) glide.go(`=${position}`);
    glide.update({ animationDuration: 500 });
  }

  GTMTrack('gallery_next', {
    position: position + 1,
  });

  state.setActiveItem(position + 1);
};

export const fromMobileGridToScroller = (position: number): void => {
  const glide = initializeGlide();
  glide?.update()?.disable();

  resizeItems();

  scrollToItem({
    itemPosition: position,
    offset: 68,
    grid: false,
  });

  state.setActiveItem(position);
};

export const handleToggleViewTransitions = (e: Event): void => {
  const target = e.currentTarget as HTMLElement;
  const { galleryItemPositionGrid: position } = target.dataset;

  state.toggleView();

  // Přechod z gridu na sliderOrScroll
  if (state.getView() === 'slideOrScroll') {
    const goToPosition = position ? parseInt(position) : 0;
    switch (state.getIsDesktop()) {
      case true:
        fromDesktopGridToSlider(goToPosition);
        break;
      case false:
        fromMobileGridToScroller(goToPosition);
        break;
    }
  }
};
